import React, {PropsWithChildren} from 'react';
import {Popover, PopoverOrigin} from '@mui/material';

const slotProps = {paper: {sx: {p: 2}}};
const anchorOrigin: PopoverOrigin = {vertical: 'bottom', horizontal: 'center'};
const transformOrigin: PopoverOrigin = {vertical: 'top', horizontal: 'center'};

interface Props {
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
}

export function FeaturePopover({anchorEl, children, setAnchorEl}: PropsWithChildren<Props>) {
  const open = Boolean(anchorEl);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      slotProps={slotProps}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={() => setAnchorEl(null)}
    >
      {children}
    </Popover>
  );
}
